import type { Expense } from '../../lib/db'

interface Props {
  expense: Expense
  onEdit: (e: Expense) => void
  onDelete: (id: string) => void
}

export default function ExpenseCard({ expense: e, onEdit, onDelete }: Props) {
  const dateStr = e.date.replace(/-/g, '/')
  const amountStr = `NT$${e.amount.toLocaleString()}`

  return (
    <div className="expense-card">
      <div className="card-top">
        <span className="card-category">{e.category}</span>
        <span className="card-amount">{amountStr}</span>
      </div>
      <div className="card-meta">
        <span>{dateStr}</span>
        {e.odometer_km != null && <span>{e.odometer_km.toLocaleString()} km</span>}
        {e.description && <span>{e.description}</span>}
      </div>
      {e.category === '油錢' && e.liters != null && (
        <p className="card-fuel">
          {e.liters} L
          {e.reminder_rule_id == null && <span className="tag-estimate">估算</span>}
        </p>
      )}
      <div className="card-actions">
        <button type="button" className="card-btn" onClick={() => onEdit(e)}>編輯</button>
        <button type="button" className="card-btn danger" onClick={() => onDelete(e.id)}>刪除</button>
      </div>
    </div>
  )
}
